import { useState, useEffect } from 'react';

interface Props {
  images: {
    id: number;
    image: string;
    alt: string;
  }[];
}

export function useRandomImage(props: Props) {
  const { images } = props;
  const [randomImage, setRandomImage] = useState(images[0]);

  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * images?.length);
    setRandomImage(images[randomIndex]);
  };

  useEffect(() => {
    getRandomImage();
  }, []);

  return { image: randomImage };
}
